import React, { useState, useRef, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../img/logo-white.png';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const navRef = useRef();

  // Fecha o menu ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Fecha o menu ao clicar em um link
  const handleNavLinkClick = () => setIsOpen(false);

  return (
    <nav
      ref={navRef}
      className="navbar navbar-expand-lg navbar-dark fixed-top"
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        backdropFilter: 'blur(10px)',
        borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
        boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
      }}
    >
      <div className="container">
        <NavLink className="navbar-brand d-flex align-items-center gap-2 fw-bold text-uppercase" to="/">
          <img src={logo} alt="Logo" style={{ height: '36px' }} loading="lazy" />
          InfoService
        </NavLink>

        <button
          className="navbar-toggler"
          type="button"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse justify-content-end ${isOpen ? 'show' : ''}`}>
          <ul className="navbar-nav gap-3 align-items-center">
            {[
              ['/', 'Início'],
              ['/servicos', 'Serviços'],
              ['/contato', 'Contato'],
              ['/suporte', 'Suporte'],
            ].map(([to, label]) => (
              <li className="nav-item" key={to}>
                <NavLink
                  to={to}
                  className={({ isActive }) =>
                    `nav-link fw-semibold ${isActive ? 'text-warning' : 'text-white'}`
                  }
                  onClick={handleNavLinkClick}
                >
                  {label}
                </NavLink>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
